// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandable-group {
  border: 1px solid var(--ods-color-purple-30);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.expandable-group__group-info {
  background-color: var(--ods-color-purple-5);
  border-bottom: 2px solid var(--ods-color-purple-30);
  display: flex;
  align-items: baseline;
  padding: 1rem 0.625rem;
}
.expandable-group__group-info--title {
  display: flex;
  align-items: baseline;
}
.expandable-group__group-info--title h2,
.expandable-group__group-info--title p {
  font-size: 1.25rem;
  line-height: 1.46;
}
.expandable-group__group-info--title .duration {
  padding-left: 0.75rem;
}
.expandable-group__group-info--status {
  position: relative;
  padding: 0 1rem;
  margin-left: auto;
}
.expandable-group__group-info--status::before {
  content: "";
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  left: -0.1rem;
  top: 0.35rem;
}
.expandable-group__group-info--status[data-status=Active]::before {
  background-color: var(--ods-color-teal-40);
}
.expandable-group__group-info--status[data-status=Terminated]::before {
  background-color: var(--ods-color-red-10) 0;
}
.expandable-group__group-info--accordion {
  height: 3.75rem;
  line-height: 3.75rem;
  background-color: var(--ods-color-purple-5);
  padding: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.expandable-group__group-info--accordion:hover {
  background-color: var(--ods-color-purple-15);
}
.expandable-group__group-info--accordion::after {
  width: 0.875rem;
  display: block;
}
.expandable-group__group-info--accordion.collapsed::after {
  transform: rotate(180deg);
}
.expandable-group__group-info--group-details {
  padding: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.875rem;
  flex-basis: 100%;
  background-color: var(--ods-color-white);
}
.expandable-group__group-info--group-details__item {
  font-size: 0.875rem;
  padding-bottom: 0.5rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0 0.35rem;
  flex: 0 0 33.3%;
  align-items: baseline;
}
.expandable-group__group-info--group-details__item dt {
  font-weight: 700;
  white-space: nowrap;
}
.expandable-group__group-info--group-details__item dd {
  margin: 0.25rem;
}
.expandable-group__group-info--group-details__item dd address {
  font-style: normal;
}
.expandable-group__group-info--group-details__item--pleft {
  padding-left: 0.625rem;
}
.expandable-group__group-info--group-details__item--full {
  flex-basis: 100%;
  padding-bottom: 0;
}
.expandable-group__group-info--group-details--detail {
  padding-left: 0.625rem;
}
.expandable-group__group-info--group-details--detail dt {
  font-weight: 400;
}
.expandable-group__group-info--group-details__update {
  padding: 0.625rem 1.25rem;
  font-weight: 700;
  font-size: 0.875rem;
  border-top: 0.063rem solid var(--ods-color-gray-5) 0;
  display: flex;
  flex-basis: 100%;
}
.expandable-group__group-info--group-details__update span {
  font-weight: 400;
}
.expandable-group__group-info--group-details__update a {
  color: var(--ods-color-purple-50);
  font-weight: 400;
  padding-left: 1rem;
}

.content__collapsed {
  display: none;
  height: 0;
  transition: all 0.3s linear;
}

@media print {
  @page {
    size: A4 landscape;
    margin: 1cm;
  }
  .no-print {
    display: none !important;
  }
  .expandable-group {
    border-radius: 4px !important;
    box-shadow: none !important;
    margin-bottom: 0.25rem !important;
    -moz-column-break-inside: avoid;
         break-inside: avoid;
  }
  .expandable-group__group-info--group-details__item {
    font-size: 0.75rem !important;
    padding-bottom: 0.2rem !important;
  }
  .expandable-group__group-info--group-details__item dt,
  .expandable-group__group-info--group-details__item dd {
    font-size: 0.75rem !important;
  }
  .expandable-group__group-info--title h2,
  .expandable-group__group-info--title p {
    font-size: 0.9rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/group-info-expanded/group-info-expanded.component.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;AACF;AACE;EACE,2CAAA;EACA,mDAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;AACJ;AACI;EACE,aAAA;EACA,qBAAA;AACN;AACM;;EAEE,kBAAA;EACA,iBAAA;AACR;AAEM;EACE,qBAAA;AAAR;AAII;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAFN;AAIM;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAFR;AAKM;EACE,0CAAA;AAHR;AAMM;EACE,2CAAA;AAJR;AAQI;EACE,eAAA;EACA,oBAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AANN;AAQM;EACE,4CAAA;AANR;AASM;EACE,eAAA;EACA,cAAA;AAPR;AAUM;EACE,yBAAA;AARR;AAYI;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;AAVN;AAYM;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAVR;AAYQ;EACE,gBAAA;EACA,mBAAA;AAVV;AAaQ;EACE,eAAA;AAXV;AAYU;EACE,kBAAA;AAVZ;AAcQ;EACE,sBAAA;AAZV;AAeQ;EACE,gBAAA;EACA,iBAAA;AAbV;AAiBM;EACE,sBAAA;AAfR;AAiBQ;EACE,gBAAA;AAfV;AAmBM;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oDAAA;EACA,aAAA;EACA,gBAAA;AAjBR;AAmBQ;EACE,gBAAA;AAjBV;AAoBQ;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;AAlBV;;AAyBA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AAtBF;;AAyBA;EACE;IACE,kBAAA;IACA,WAAA;EAtBF;EAyBA;IACE,wBAAA;EAvBF;EA0BA;IACE,6BAAA;IACA,2BAAA;IACA,iCAAA;IACA,+BAAA;SAAA,mBAAA;EAxBF;EA2BA;IACE,6BAAA;IACA,iCAAA;EAzBF;EA2BE;;IAEE,6BAAA;EAzBJ;EA6BA;;IAEE,4BAAA;EA3BF;AACF","sourcesContent":[".expandable-group {\n  border: 1px solid var(--ods-color-purple-30);\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n  &__group-info {\n    background-color: var(--ods-color-purple-5);\n    border-bottom: 2px solid var(--ods-color-purple-30);\n    display: flex;\n    align-items: baseline;\n    padding: 1rem 0.625rem;\n\n    &--title {\n      display: flex;\n      align-items: baseline;\n\n      h2,\n      p {\n        font-size: 1.25rem;\n        line-height: 1.46;\n      }\n\n      .duration {\n        padding-left: 0.75rem;\n      }\n    }\n\n    &--status {\n      position: relative;\n      padding: 0 1rem;\n      margin-left: auto;\n\n      &::before {\n        content: \"\";\n        border-radius: 50%;\n        width: 0.75rem;\n        height: 0.75rem;\n        position: absolute;\n        left: -0.1rem;\n        top: 0.35rem;\n      }\n\n      &[data-status=\"Active\"]::before {\n        background-color: var(--ods-color-teal-40);\n      }\n\n      &[data-status=\"Terminated\"]::before {\n        background-color: var(--ods-color-red-10) 0;\n      }\n    }\n\n    &--accordion {\n      height: 3.75rem;\n      line-height: 3.75rem;\n      background-color: var(--ods-color-purple-5);\n      padding: 0.25rem;\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: var(--ods-color-purple-15);\n      }\n\n      &::after {\n        width: 0.875rem;\n        display: block;\n      }\n\n      &.collapsed::after {\n        transform: rotate(180deg);\n      }\n    }\n\n    &--group-details {\n      padding: 1.25rem;\n      display: flex;\n      flex-wrap: wrap;\n      font-size: 0.875rem;\n      flex-basis: 100%;\n      background-color: var(--ods-color-white);\n\n      &__item {\n        font-size: 0.875rem;\n        padding-bottom: 0.5rem;\n        display: grid;\n        grid-template-columns: max-content 1fr;\n        gap: 0 0.35rem;\n        flex: 0 0 33.3%;\n        align-items: baseline;\n\n        dt {\n          font-weight: 700;\n          white-space: nowrap;\n        }\n\n        dd {\n          margin: 0.25rem;\n          address {\n            font-style: normal;\n          }\n        }\n\n        &--pleft {\n          padding-left: 0.625rem;\n        }\n\n        &--full {\n          flex-basis: 100%;\n          padding-bottom: 0;\n        }\n      }\n\n      &--detail {\n        padding-left: 0.625rem;\n\n        dt {\n          font-weight: 400;\n        }\n      }\n\n      &__update {\n        padding: 0.625rem 1.25rem;\n        font-weight: 700;\n        font-size: 0.875rem;\n        border-top: 0.063rem solid var(--ods-color-gray-5) 0;\n        display: flex;\n        flex-basis: 100%;\n\n        span {\n          font-weight: 400;\n        }\n\n        a {\n          color: var(--ods-color-purple-50);\n          font-weight: 400;\n          padding-left: 1rem;\n        }\n      }\n    }\n  }\n}\n\n.content__collapsed {\n  display: none;\n  height: 0;\n  transition: all 0.3s linear;\n}\n\n@media print {\n  @page {\n    size: A4 landscape;\n    margin: 1cm;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n\n  .expandable-group {\n    border-radius: 4px !important;\n    box-shadow: none !important;\n    margin-bottom: 0.25rem !important;\n    break-inside: avoid;\n  }\n\n  .expandable-group__group-info--group-details__item {\n    font-size: 0.75rem !important;\n    padding-bottom: 0.2rem !important;\n\n    dt,\n    dd {\n      font-size: 0.75rem !important;\n    }\n  }\n\n  .expandable-group__group-info--title h2,\n  .expandable-group__group-info--title p {\n    font-size: 0.9rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
